package com.neurobs.ccabserver.administrator.contexts

import com.neurobs.ccab.ControllerSessionData
import com.neurobs.ccabserver.administrator.controller.ControllerSessionController
import com.neurobs.react.{StateAttribute, StateContextBase}

case class TestStationState
(
//	stations: Seq[ControllerSessionData] = Seq(),
	examiners: Seq[ControllerSessionController] = Seq()
)

class TestStationContext(state: StateAttribute[TestStationState]) {
	def data: TestStationState = state.value

//	def setStations(newStations: Seq[ControllerSessionData]): Unit = {
//		val sorted = newStations.sortWith((l, r) => l.sessionId < r.sessionId)
//		if (data.stations != sorted) {
//			state.setValue(data.copy(stations = sorted))
//		}
//	}

	def addExaminer(c: ControllerSessionController): Unit = {
		if (!data.examiners.exists(_.sessionInfo.sessionId == c.sessionInfo.sessionId)) {
			state.setValue(data.copy(examiners = data.examiners :+ c))
		}
	}

	def removeExaminer(c: ControllerSessionController): Unit = {
		if (data.examiners.contains(c)) {
			state.setValue(data.copy(examiners = data.examiners.filterNot(_ == c)))
		}
	}
}

object TestStationContext extends StateContextBase[TestStationContext, TestStationState] {
	override protected def defaultStateValue(): TestStationState = TestStationState()

	override protected def makeState(a: StateAttribute[TestStationState]): TestStationContext = new TestStationContext(a)
}
